import axios from "axios";
import { buildHeaders } from "@/services/_headers.util";

const API_URL = `${process.env.VUE_APP_API_URL}ticket-categories/`;
const STATS_URL = `${process.env.VUE_APP_API_URL}tickets/category-stats`;

export default {
  getAll() {
    return axios.get(API_URL, { headers: buildHeaders() });
  },
  create(data) {
    return axios.post(API_URL, data, { headers: buildHeaders() });
  },
  update(id, data) {
    return axios.put(`${API_URL}${id}`, data, { headers: buildHeaders() });
  },
  delete(id) {
    return axios.delete(`${API_URL}${id}`, { headers: buildHeaders() });
  },
  stats(params={}) {
    return axios.get(STATS_URL, { params, headers: buildHeaders() });
  }
  
};
